import { Link, useLocation } from 'react-router-dom';
import PageLayout from '@/components/feature/PageLayout';
import SeoHead from '@/components/feature/SeoHead';

export default function NotFound() {
  const location = useLocation();

  return (
    <PageLayout>
      <SeoHead
        title="页面不存在 · 911吃瓜"
        description="你访问的页面不存在或已被移动，返回首页继续浏览人物关系图、矛盾链条与当事人回应。"
        keywords="911吃瓜,页面不存在"
        path={location.pathname}
      />
      <section className="w-full px-4 md:px-8 pt-32 pb-24 text-center">
        <p className="font-heading font-black text-7xl md:text-9xl text-background-300 select-none">404</p>
        <h1 className="mt-6 font-heading font-black text-2xl md:text-3xl text-foreground-950">这个瓜田里没有这页</h1>
        <p className="mt-3 text-sm text-foreground-600 break-all">{location.pathname}</p>
        <p className="mt-4 text-sm text-foreground-600">页面可能已被移动或改名，回首页继续逛逛吧。</p>
        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-5 py-3 rounded-md bg-primary-500 text-background-50 font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            <i className="ri-home-4-line" />
            返回首页
          </Link>
          <Link
            to="/cases"
            className="inline-flex items-center gap-2 px-5 py-3 rounded-md border border-foreground-300 text-foreground-800 font-semibold hover:bg-background-100 transition-colors whitespace-nowrap"
          >
            <i className="ri-fire-line" />
            浏览吃瓜事件库
          </Link>
        </div>
      </section>
    </PageLayout>
  );
}